// calculated fields
var MDB = window.MDB || {};;
(function ($, global) {
    function Namespace() { }

    MDB.WidgetEditor = MDB.WidgetEditor || {};
    //var Calc = MDB.WidgetEditor.Calc = new EventEmitter();
    var Calc = MDB.WidgetEditor.Calc = {};

    var grammarUrl = $('body').data('siteroot') || '/';
    grammarUrl += "Scripts/Core/expressions/grammar.peg";

    
    var calcReady = function (callback) {
        if (callback) {
            Calc._loadParser().done(callback);
        }
    };
        
    var idCounter = 0,
        idPrefix = "MdbWeCalcId",
        log = function (msg) {
            console.log(msg);
        };

    
    $.extend(MDB.WidgetEditor.Calc, {
        log: log,
        /** call ready(function() { ...}) or ready.done(function() { ... }) 
            if you want to be sure that the parser is ready before you begin.
        */
        ready: calcReady,



        startExpresssionMonitor: function (col,container, selector, callback) {
            this._loadParser().done(function (parser) {
                var input = container.find(selector);
                var lastValue = '',
                    timeOut = false;
                input.bind('change keyup', function (e) {
                    var parserDelay = 250;
                    
                    var newValue = this.value;
                    if (newValue != lastValue) {
                        if (timeOut) {
                            clearTimeout(timeOut);
                        }

                        timeOut = setTimeout(function () {
                            timeOut = false;
                            lastValue = newValue;
                            col.Expression = newValue;
                            //parse
                            var compiler = new Calc.Compiler();
                            compiler.compile(newValue)
                                .fail(function (err) {
                                    callback(err, newValue, '');
                                }).done(function (ast) {
                                    col.Expression = newValue;
                                    col.ExpressionAST = JSON.stringify(ast, null, ' ');
                                    callback(null, newValue, ast);
                                });


                        }, parserDelay);
                    }
                });
                if (input.val()) {
                    input.trigger('change');
                }
            });
        },





        _loadParser: function () {
            if (this._loadParserPromise) {
                return this._loadParserPromise;
            }
            var grammarLoader = new $.Deferred();
            this._loadParserPromise = grammarLoader
            $.ajax({ url: grammarUrl, dataType: 'text' })
                .fail(function (err) {
                    grammarLoader.reject(err);
                })
                .done(function (text, status, xhr) {
                    var start = new Date().getTime();

                    var continueWith = function continueWithBuildingParser(rebuildCompiler, grammar, cacheKey) {
                        var parserSource = null;
                        if (rebuildCompiler) {
                            // compile the compiler
                            if (typeof (PEG) === 'undefined') {
                                throw "PEG library not found";
                            }
                            try {
                                log("Compiling the compiler");
                                //Calc.grammar = grammar;
                                Calc.parser = null;
                                parserSource = PEG.buildParser(grammar, {
                                    output: 'source' // output: 'parser'
                                });
                            } catch (e) {
                                if (e.line !== undefined && e.column !== undefined) {
                                    console.error(e.line + ":" + e.column + ": " + e.message);
                                    alert(e.line + ":" + e.column + ": " + e.message);
                                } else {
                                    console.error(e.message);
                                    //if(typeof(console) !== 'undefined' && console.error) console.error(e);
                                    alert(e.message);
                                }
                            }
                            Calc.parser = eval(parserSource);

                            localforage.setItem('peg-calc-parser-source', parserSource, function (err) {
                                if (!err) {
                                    localforage.setItem('peg-calc-cachekey', cacheKey);
                                }
                            });
                            log("Finished compiling the compiler in " + (new Date().getTime() - start) + " ms");
                            grammarLoader.resolve(Calc.parser);
                        } else {
                            localforage.getItem('peg-calc-parser-source', function (err, parserSource) {

                                try {
                                    if (err) {
                                        throw err;
                                    }
                                    if (!parserSource) {
                                        throw "missing source";
                                    }
                                    log("Loading the cached compiler");
                                    Calc.parser = eval(parserSource);
                                    log("Finished loading the cached compiler in " + (new Date().getTime() - start) + " ms");

                                    grammarLoader.resolve(Calc.parser);
                                } catch (e) {
                                    console.warn("Error evalling the stored compiler")
                                    console.log(e)
                                    // if we have an error loading or evalling the parser, than we re-invoke ourself to force recompiling it.
                                    continueWithBuildingParser(true, grammar, cacheKey);
                                }
                            });

                        }

                    };

                    var cacheKey = false;
                    if (xhr && xhr.getResponseHeader) {
                        var etag = xhr.getResponseHeader('ETag'),
                            lastModified = xhr.getResponseHeader('Last-Modified');                            
                        if (etag || lastModified) {
                            cacheKey = ('' + etag + lastModified).replace(new RegExp(/[^a-zA-Z0-9]+/, "g"), "-");
                        }
                    }
                    if (!cacheKey) {
                        // continue
                        continueWith(true, text, cacheKey);
                    } else {
                        localforage.getItem('peg-calc-cachekey', function (err, value) {                            
                            if (!err && value == cacheKey) {
                                // use cached version
                                continueWith(false, text, cacheKey);
                            } else {
                                continueWith(true, text, cacheKey);
                            }
                        })
                    }

                });
            return grammarLoader.promise();
        },






        ns: function (ns) {
            var o = global, p = ns.split('.'), c;
            for (var i = 0, il = p.length; i < il; i++) {
                c = p[i];
                /* we only use a constructor to make the console.log statements more pretty */
                //o = o[c] = o[c] || {};
                o = o[c] = o[c] || new Namespace();
            }
            return o;
        },
        /** generate a unique id */
        id: function (prefix) {
            var p = '_';
            if (prefix) {
                p += prefix + '_';
            }
            return [idPrefix, p, (idCounter++)].join('');
        },
        //copies all properties from one object to another
        apply: function (target, src, defaults) {
            var i, x, args = arguments, currentArg;
            for (i = args.length - 1; i > 0; i--) {
                currentArg = args[i];
                if (currentArg) {
                    for (x in currentArg) {
                        if (currentArg.hasOwnProperty(x)) {
                            target[x] = currentArg[x];
                        }
                    }
                }
            }
            return target;
        },
        //copy all properties from one object to another, but only if they don't exist
        applyIf: function (target, src, defaults) {
            var i, x, args = arguments, currentArg, argsLength = args.length;
            for (i = 1; i < argsLength; i++) {
                currentArg = args[i];
                if (currentArg) {
                    for (x in currentArg) {
                        if (target[x] === undefined) {
                            if (currentArg.hasOwnProperty(x)) {
                                target[x] = currentArg[x];
                            }
                        }
                    }
                }
            }
            return target;
        },
        delegate: function (fn, scope) {
            // Note we cant use the ES5 Function.prototype.bind here because then we need to know the arguments in advance
            var s = scope || this;
            return function () {
                fn.apply(s, arguments);
            };
        },

        /** process all properties for the given object 
         * @param {Object} target - the object to iterate
         * @param {Function} callback - a callback to call for each property, the parameters that are passed are: propertyname, propertyvalue. 
         *                   the callback function is executed in the scope of the target object
         */
        eachProperty: function (target, callback) {
            if (!target) {
                return; 
            }
            //todo: detect array
            var keys = Object.keys(target);
            for (var i = 0, il = keys.length; i < il; i++) {
                var prop = keys[i];

                //if the callback returns false, cancel the loop
                if (callback.call(target, prop, target[prop], i) === false) {
                    return;
                }
            }
        },


        copyArray: function (src, dst) {
            if (!dst) {
                return ArrayPrototype.concat.call([], src);
            }
            dst = dst || [];
            for (var i = 0, il = src.length; i < il; i++) {
                dst[i] = src[i];
            }
            return dst;
        },
        /** concats all arrays into the first */
        concatArray: function (src1, src2, src3, src4) {
            //return ArrayPrototype.concat.apply([], arguments);

            var dst = src1,
                src;
            for (var j = 1, jl = arguments.length; j < jl; j++) {
                var src = arguments[j];
                for (var i = 0, il = src.length; i < il; i++) {
                    dst.push(src[i]);
                }
            }
            return dst;
        },
        





        __iefix: 0
    });

    
})(jQuery, this);